/** Default TanStack Query garbage collection time (10 minutes). */
export const DEFAULT_GC_TIME_MS = 10 * 60 * 1000;

/** Default TanStack Query stale time (5 minutes). */
export const DEFAULT_STALE_TIME_MS = 5 * 60 * 1000;

/** Languages that use right-to-left text direction. */
export const RTL_LANGUAGES = ['ar', 'he', 'fa'] as const;

/** Native display names for language codes, used by language switchers. */
export const LANGUAGE_LABELS: Record<string, string> = {
  ar: 'العربية',
  en: 'English',
  fr: 'Français',
};

/** Default number of items per page for data tables. */
export const DEFAULT_PAGE_SIZE = 10;

/** Default debounce delay (in ms) for search inputs. */
export const SEARCH_DEBOUNCE_MS = 300;

/**
 * Convenience type for the `data` returned by a paginated `useQuery()` call.
 * Typically `PaginatedResponse<T> | undefined` — this picks only the fields
 * that page-level hooks need to derive UI state.
 */
export type PaginatedData<T> = { items: T[]; total: number; totalPages: number } | undefined;
